import UpdateSubscriptionsModal from './UpdateSubscriptionsModal';

export default UpdateSubscriptionsModal;
